export default "__VITE_ASSET__DX7wF5gN__"